import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "/logo-transparent.png";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/95 shadow-md border-b border-[#a8d8ea]/30"
          : "bg-white/90 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2"
            data-testid="navbar-logo-button"
          >
            <img
              src={LOGO_URL}
              alt="Liv's Car Wash"
              className="h-12 w-auto"
              data-testid="navbar-logo"
            />
          </button>

          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-[#1a2744] font-bold hover:text-[#c0392b] transition-colors duration-200 text-sm"
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick("#booking")}
              className="bg-[#a8d8ea] text-[#1a2744] rounded-full px-6 py-2.5 font-bold text-sm hover:-translate-y-0.5 hover:shadow-lg hover:bg-[#7fc8e0] transition-all duration-300"
              data-testid="nav-book-now-button"
            >
              Book Now
            </button>
          </div>

          <button
            className="md:hidden text-[#1a2744] p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="nav-mobile-menu-button"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#a8d8ea]/30 py-4 px-4 shadow-lg">
          <div className="flex flex-col gap-3">
            {NAV_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-[#1a2744] font-bold hover:text-[#c0392b] transition-colors text-left py-2 border-b border-[#a8d8ea]/20 last:border-0"
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick("#booking")}
              className="bg-[#a8d8ea] text-[#1a2744] rounded-full px-6 py-3 font-bold text-center mt-2"
              data-testid="mobile-nav-book-now-button"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
